import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCopy, FiCheck } = FiIcons;

const PromptCard = ({ prompt, index }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(prompt);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Simple parser to make the prompt look nicer (bolding the tags)
  const formatPrompt = (text) => {
    const parts = text.split(/(\[.*?\])/g);
    return parts.map((part, i) => {
      if (part.startsWith('[') && part.endsWith(']')) {
        return <strong key={i} className="text-orange-800 font-semibold">{part}</strong>;
      }
      return <span key={i} className="text-stone-600">{part}</span>;
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      whileHover={{ y: -4 }}
      className="bg-white rounded-2xl p-6 shadow-sm border border-orange-100 hover:shadow-md hover:border-orange-300 transition-all group relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-400 to-red-400 opacity-0 group-hover:opacity-100 transition-opacity" />
      
      <div className="flex justify-between items-start gap-4 mb-3">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange-50 text-orange-600 font-bold text-sm">
          #{index + 1}
        </span>
        <button
          onClick={handleCopy}
          className={`p-2 rounded-lg transition-colors flex items-center gap-2 text-sm font-medium ${
            copied 
              ? 'bg-green-50 text-green-600' 
              : 'bg-stone-50 text-stone-500 hover:bg-orange-50 hover:text-orange-600'
          }`}
          title="Copy to clipboard"
        >
          <SafeIcon icon={copied ? FiCheck : FiCopy} />
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      
      <p className="text-sm leading-relaxed pr-2">
        {formatPrompt(prompt)}
      </p>
    </motion.div>
  );
};

export default PromptCard;